import { ArrowDownRight, ArrowUpRight, Pencil, Trash2 } from "lucide-react";
import { money, shortDate } from "../lib/format";

export default function TransactionRow({ item, onDelete, onEdit }) {
  const income = item.type === "income";
  return (
    <div className="transaction-row" data-testid={`transaction-${item.id}`}>
      <div className={`tx-mark ${income ? "income" : "expense"}`}>
        {income ? <ArrowDownRight size={16} /> : <ArrowUpRight size={16} />}
      </div>
      <div className="tx-main">
        <strong>{item.description}</strong>
        <span>
          {item.category}
          {item.account ? ` · ${item.account}` : ""}
          {item.contact ? ` · ${item.contact}` : ""}
        </span>
      </div>
      <div className="tx-date">{shortDate(item.date)}</div>
      <div className={`tx-amount ${income ? "income-text" : "expense-text"}`}>
        {income ? "+" : "−"}
        {money(item.amount)}
      </div>
      <div className="tx-actions">
        {onEdit ? (
          <button
            className="icon-btn ghost"
            onClick={() => onEdit(item)}
            data-testid={`edit-transaction-${item.id}`}
            aria-label="Düzenle"
          >
            <Pencil size={14} />
          </button>
        ) : null}
        {onDelete ? (
          <button
            className="icon-btn ghost"
            onClick={() => onDelete(item)}
            data-testid={`delete-transaction-${item.id}`}
            aria-label="Sil"
          >
            <Trash2 size={14} />
          </button>
        ) : null}
      </div>
    </div>
  );
}
